import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ComposeEmailComponent } from '../modules/email/compose-email/compose-email.component';

export interface EmailComposeOptions {
  /** Link the mail to a record (shows in that record's Email tab). */
  moduleId?: number | string | null;
  moduleDataId?: number | string | null;
  moduleName?: string;
  referenceName?: string;
  /** Optional prefilled subject / body (e.g. a share-via-email action). */
  subject?: string;
  body?: string;
  /** For UI-only preview flows with no real account to send from (e.g. the
   * Cancel Job Purchase Order Settlement screen's mock vendors) — skips the
   * real validation/send call in ComposeEmailComponent.send() entirely and
   * just closes the dialog, instead of surfacing "Please select an email
   * account to send from" for something that was never going to be a real
   * send. Only affects callers that explicitly pass this; every other caller
   * is unaffected. */
  mockSend?: boolean;
}

/**
 * Opens the in-app compose modal (the shared right-hand-drawer ComposeEmailComponent)
 * instead of handing off to Outlook/Gmail via mailto:. Used by both the
 * `appEmailCompose` directive (template links) and component click-handlers that
 * previously did `window.location.href = 'mailto:…'`.
 */
@Injectable({ providedIn: 'root' })
export class EmailComposeService {
  constructor(private dialog: MatDialog) {}

  open(email?: string, opts: EmailComposeOptions = {}): void {
    const data: any = { mode: 'compose' };

    if (email) {
      data.prefillTo = email;
    }
    if (opts.moduleId && opts.moduleDataId) {
      data.moduleId = opts.moduleId;
      data.moduleDataId = opts.moduleDataId;
      data.moduleName = opts.moduleName;
      data.referenceName = opts.referenceName;
      data.lockModuleLink = true;
    }
    if (opts.subject) {
      data.prefillSubject = opts.subject;
    }
    if (opts.body) {
      data.prefillBody = opts.body;
    }
    if (opts.mockSend) {
      data.mockSend = true;
    }

    this.dialog.open(ComposeEmailComponent, {
      width: '600px',
      height: '100vh',
      position: { right: '0' },
      panelClass: ['compose-email-dialog', 'righthand-drawer'],
      hasBackdrop: true,
      data,
    });
  }
}
